function loadImageHeight() {
  const bannerImage = document.querySelector(".mega-menu-deals-image");
  if (bannerImage == null) return;
  let height = [];

  bannerImage.parentElement.querySelectorAll("div[role='group']").forEach((item, index)=>{
    height[index] = 0;
    item.childNodes.forEach((node) => {
      if (node.nodeType === 1) {
        height[index] += node.clientHeight;
      }
    });
  })
  bannerImage.style.height = Math.max(...height) + 9 + "px";
}

const menuItems = document.querySelectorAll(".mega-menu-item:not(.disabled) button");
const allMenuItems = document.querySelectorAll(".site-header__menu-item:not(.mega-menu-item)");

// SCROLL PROTECTION: Track scroll state to prevent accidental mega menu triggers
let isScrolling = false;
let scrollTimeout;

// Debounced scroll handler to track scroll state
const handleScroll = () => {
  isScrolling = true;
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(() => {
    isScrolling = false;
  }, 100); // Reduced from 150ms to 100ms for quicker recovery
};

window.addEventListener('scroll', handleScroll, { passive: true });

if (allMenuItems && allMenuItems?.length) {
  allMenuItems.forEach((menu) => {
    if (menu) {
      menu.addEventListener("mouseover", closeMegaMenu);
    }
  })
}

menuItems.forEach((item) => {
  // CONSERVATIVE: Add minimal scroll protection with very short debounce
  let hoverTimeout;
  
  item.addEventListener("mouseover", async function () {
    // SCROLL PROTECTION: Only block during active scrolling
    if (isScrolling) {
      return;
    }
    
    // Minimal debounce to prevent scroll-induced accidental triggers
    clearTimeout(hoverTimeout);
    hoverTimeout = setTimeout(async () => {
      // Quick recheck - if still scrolling, bail out
      if (isScrolling) {
        return;
      }
      
      if (item.getAttribute("aria-expanded") == "true") {
      //  closeMegaMenu();
      } else {
        menuItems.forEach((item) => {
          item.setAttribute("aria-expanded", false);
          item.parentElement.classList.remove("active");
        });
        document.querySelectorAll(".header-mega-menu").forEach((item) => {
          item.classList.remove("mega-menu-open");
          item.innerHTML = "";
        });
        const megaMenuContent = window.calpak.megamenu[item.dataset.handle];
        const megaMenu = document.querySelector(
          `#mega-menu-region-${item.dataset.handle}`
        );
        megaMenu.classList.add("mega-menu-open");
        megaMenu.innerHTML = megaMenuContent;
        item.parentElement.classList.add("active");
        item.setAttribute("aria-expanded", true);

        megaMenu.querySelector(".mega-menu-section").addEventListener("mouseleave", () => {
          closeMegaMenu();
        });

        document.addEventListener('touchstart', (event) => {
          if(megaMenu.querySelector(".mega-menu-section")){
            const isOutside = !megaMenu.querySelector(".mega-menu-section").contains(event.target);

            if (isOutside) {
              closeMegaMenu();
            }
          }
        });

        megaMenu
          .querySelector(".close-btn")
          .addEventListener("click", function () {
            closeMegaMenu();
          });

        document
          .querySelector(".site-mega-menu-header__overlay")
          ?.classList.add("active");

        const loadQuickAdd = () => {
          console.log("loadQuickAdd");
          const productGrid = document.querySelector(".mega-menu-content-deals");
          document
            .querySelectorAll(".mega-menu-content-deals .quick-view__link")
            .forEach((link) => link.classList.add("hide"));
          document
            .querySelector(".mega-menu-content-deals")
            .classList.add("product-grid--gap");
          document
            .querySelectorAll(".mega-menu-content-deals .product-unit")
            .forEach((productUnit) => {
              productUnit.classList.add("product-unit--quickadd");
            });
          document
            .querySelectorAll(".mega-menu-content-deals .product-unit__colors")
            .forEach((colors) => {
              colors.classList.add("product-unit__colors--all", "slide");
              colors.parentNode.parentNode
                .querySelector(".product-unit__colors--quickadd")
                .append(colors);
            });
          const productUnits = productGrid.querySelectorAll(".product-unit");

          console.log("loadQuickAdd productUnits length", productUnits.length);

          productUnits.forEach((productUnit) => {
            const colors = productUnit.querySelector(".product-unit__colors");

            if (colors) {
              // Find the quickadd colors container
              const colorsQuickAdd = productUnit.querySelector(
                ".product-unit__colors--quickadd"
              );

              if (colorsQuickAdd) {
                if (!colorsQuickAdd.contains(colors)) {
                  colors.classList.add("product-unit__colors--all", "slide");

                  colorsQuickAdd.appendChild(colors);
                }
              }
            }
          });
          document
            .querySelectorAll(".mega-menu-content-deals .product-unit__button")
            .forEach((productUnitButton) =>
              productUnitButton.classList.add("product-unit__button--active")
            );
          document
            .querySelectorAll(".mega-menu-content-deals .product-unit__swatches")
            .forEach((swatches) => {
              swatches.classList.add("slider");
              const sliderWrapper = swatches.parentNode;
              sliderWrapper.setAttribute("data-slide", 4);
              sliderWrapper.setAttribute("data-slide-mob", 2);
              sliderWrapper.classList.add(
                "slider__wrapper",
                "slider__wrapper--start"
              );
            });
        };

        //extract below to a function and execute it when window size changes

        if (document.querySelector(".mega-menu-content-deals") != null) {
          const productUnits = document.querySelectorAll(
            ".mega-menu-content-deals .product-unit"
          );
          productUnits.forEach((item) => {
            if (calpak.productUnitsObserver)
              calpak.productUnitsObserver.observe(item);
          });
          loadQuickAdd();
          
          window.addEventListener("resize", loadImageHeight);
          loadImageHeight();
        }
      }
    }, 50); // Reduced from 100ms to 50ms - barely perceptible but prevents scroll conflicts
  });

  const isTouchDevice = 
  'ontouchstart' in window || 
  navigator.maxTouchPoints > 0 || 
  navigator.msMaxTouchPoints > 0 || 
  window.matchMedia("(pointer: coarse)").matches;

  if (!isTouchDevice) {
  item.addEventListener("click", function(){

      location.href = item.dataset.url;
    })
  }

});

function closeMegaMenu(e) {
  let isMegaMenu = true;
  if (e) {
    isMegaMenu = e?.target?.classList?.contains("mega-menu-item");
  }
  const activeMegaMenuItem = document.querySelector(".mega-menu-item.active");
  if (activeMegaMenuItem != null) {
    activeMegaMenuItem.classList.remove("active");
    activeMegaMenuItem
      .querySelector("button")
      .setAttribute("aria-expanded", false);
    activeMegaMenuItem
      .querySelector(".header-mega-menu")
      .classList.remove("mega-menu-open");
    activeMegaMenuItem.querySelector(".header-mega-menu").innerHTML = "";
    document
      .querySelector(".site-mega-menu-header__overlay.active")
      ?.classList.remove("active");

    // if (isMegaMenu) activeMegaMenuItem.querySelector("button").focus();
    // else activeMegaMenuItem.querySelector('button').blur();
  }
  menuItems.forEach((item) => {
    if (isMegaMenu && item.parentNode.dataset.active == "true") {
      item.parentNode.classList.add("active");
    } else {
      if (!activeMegaMenuItem && item) {
        item.blur();
      }
    }
  });
}

const bagLink = document.querySelectorAll(".open-cart-link");

bagLink.forEach(function (element) {
  element.addEventListener("click", async function (e) {
    closeMegaMenu();
  });
});

const searchLink = document.querySelector(".header__search-link");

searchLink.addEventListener("click", function (event) {
  closeMegaMenu();
});

document.body.addEventListener("keydown", function (e) {
  if (e.key == "Escape") {
    closeMegaMenu();
  }
});

//GTM implementation
// TODO, reduce scope of click listener after nav speed updates?
document.addEventListener("click", function (e) {
  if (e.target.classList.contains("slide-menu__accordion-button")) {
    return;
  }
  if (e.target.closest(".slider__wrapper .slider .product-unit-lite") != null) {
    const curMenuItem = e.target.closest(
      ".slider__wrapper .slider .product-unit-lite"
    );
    const cardnumber = curMenuItem.dataset.cardnumber;
    if (
      curMenuItem.parentElement.closest("li.slide-menu-item--has-sub") != null
    ) {
      dataLayer.push({
        event: "nav_click",
        nav_click_value: `mobile-item-sub-${
          curMenuItem.parentElement.closest("li.slide-menu-item--has-sub")
            .dataset.handle
        }-best-sellers-product-${cardnumber}`,
      });
    }
    return;
  }
  if (e.target.closest("li.slide-menu-item-shop-all") != null) {
    dataLayer.push({
      event: "nav_click",
      nav_click_value: `mobile-item-sub-${
        e.target.closest("li.slide-menu-item--single").dataset.handle
      }-shop-all`,
    });
    return;
  }
  if (e.target.closest("li.slide-menu-item--promo") != null) {
    dataLayer.push({
      event: "nav_click",
      nav_click_value: "mobile-item-promo-banner",
    });
    return;
  }
  if (e.target.closest("li.slide-menu-item--flash") != null) {
    dataLayer.push({
      event: "nav_click",
      nav_click_value: `mobile-item-flash-${calpak.handleize(
        e.target.textContent
      )}`,
    });
    return;
  }
  if (e.target.closest("li.slide-menu-item--single") != null) {
    const curMenuItem = e.target.closest("li.slide-menu-item--single");
    const cur_handle = curMenuItem.dataset.handle;
    if (
      curMenuItem.parentElement.closest("li.slide-menu-item--has-sub") != null
    ) {
      dataLayer.push({
        event: "nav_click",
        nav_click_value: `mobile-item-sub-${
          curMenuItem.parentElement.closest("li.slide-menu-item--has-sub")
            .dataset.handle
        }-${cur_handle}`,
      });
    } else {
      dataLayer.push({
        event: "nav_click",
        nav_click_value: `mobile-item-${cur_handle}`,
      });
    }
    return;
  }
  if (e.target.closest("li.slide-menu-item--has-sub") != null) {
    dataLayer.push({
      event: "nav_click",
      nav_click_value: `mobile-item-sub-${e.target.dataset.handle}`,
    });
    return;
  }
});

document.addEventListener("click", function (e) {
  if (e.target.classList.contains("nav-menu")) {
    dataLayer.push({
      event: "nav_click",
      nav_click_value: `nav-item-${calpak.handleize(e.target.dataset.target)}`,
    });
    return;
  }
  if (e.target.classList.contains("mega-menu")) {
    dataLayer.push({
      event: "nav_click",
      nav_click_value: `mega-menu-item-${e.target.dataset.handle}`,
    });
    return;
  }
  if (e.target.parentElement?.classList.contains("shop-all-btn")) {
    const collectionHandle =
      e.target.closest(".header-mega-menu").dataset.handle;
    dataLayer.push({
      event: "nav_click",
      nav_click_value: `mega-menu-shop-all-${collectionHandle}`,
    });
    return;
  }
  if (e.target.parentElement?.classList.contains("menu-item-category")) {
    const collectionHandle =
      e.target.closest(".header-mega-menu").dataset.handle;
    dataLayer.push({
      event: "nav_click",
      nav_click_value: `mega-menu-${collectionHandle}-${calpak.handleize(
        e.target.textContent
      )}`,
    });
    return;
  }
  if (e.target.parentElement?.classList.contains("menu-item-color")) {
    const collectionHandle =
      e.target.closest(".header-mega-menu").dataset.handle;
    dataLayer.push({
      event: "nav_click",
      nav_click_value: `mega-menu-${collectionHandle}-${calpak.handleize(
        e.target.textContent
      )}`,
    });
    return;
  }
  if (e.target.parentElement?.classList.contains("menu-item-feature")) {
    const collectionHandle =
      e.target.closest(".header-mega-menu").dataset.handle;
    dataLayer.push({
      event: "nav_click",
      nav_click_value: `mega-menu-${collectionHandle}-${calpak.handleize(
        e.target.textContent
      )}`,
    });
    return;
  }
  const bestSellersProductList = document.querySelector(
    ".header-mega-menu .best-sellers-products-list"
  );
  if (bestSellersProductList != null) {
    if (bestSellersProductList.contains(e.target)) {
      const productCard = e.target.closest(".product-unit-lite");
      const collectionHandle =
        e.target.closest(".header-mega-menu").dataset.handle;
      dataLayer.push({
        event: "nav_click",
        nav_click_value: `mega-menu-${collectionHandle}-best-sellers-product-${productCard.dataset.cardnumber}`,
      });
    }
  }
  const bestSellingCollectionList = document.querySelector(
    ".header-mega-menu .best-sellings-collection-list"
  );
  if (bestSellingCollectionList != null) {
    if (bestSellingCollectionList.contains(e.target)) {
      const collectionCard = e.target.closest(".collection-item");
      const collectionHandle =
        e.target.closest(".header-mega-menu").dataset.handle;
      dataLayer.push({
        event: "nav_click",
        nav_click_value: `mega-menu-${collectionHandle}-collections-${collectionCard.dataset.cardnumber}`,
      });
    }
  }
  const featuredCollection = document.querySelector(
    ".header-mega-menu .featured-collection"
  );
  if (featuredCollection != null) {
    if (featuredCollection.contains(e.target)) {
      const collectionHandle =
        e.target.closest(".header-mega-menu").dataset.handle;
      dataLayer.push({
        event: "nav_click",
        nav_click_value: `mega-menu-${collectionHandle}-featured-collection`,
      });
    }
  }
});

document.addEventListener('calpak:loaded', function() {
  const customSelect = document.querySelector('.custom-select');
  const customDropdownOptions = document.querySelector('.custom-dropdown-options');
  const selectElement = document.getElementById('country-select');
  const flagElement = customSelect.querySelector('.flag-icon');
  const customDropdown = customSelect.closest('.custom-dropdown'); 

  customSelect.addEventListener('click', function() {
    const isOpen = !customDropdownOptions.hidden;
    customDropdownOptions.hidden = isOpen;
    customDropdown.classList.toggle('open');
    customDropdown.setAttribute('aria-expanded', !isOpen);
    selectElement.setAttribute('aria-hidden', isOpen);
  });

  customSelect.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      customSelect.click();
    }
  });

  document.querySelectorAll('.dropdown-option').forEach(option => {
    option.addEventListener('click', function() {
      const selectedCountryCode = option.querySelector('.flag-icon').classList;
      
      flagElement.classList = selectedCountryCode;
      selectElement.value = option.getAttribute('data-value');
      selectElement.form.submit();
      closeDropdown();
    });

    option.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
        option.click();
      }
    });
  });

  document.addEventListener('click', function(event) {
    if (!customSelect.contains(event.target) && !customDropdownOptions.contains(event.target)) {
      closeDropdown();
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && !customDropdownOptions.hidden) {
      closeDropdown();
    }
  });

  function closeDropdown() {
    customDropdownOptions.hidden = true;
    customDropdown.classList.remove('open');
    customDropdown.setAttribute('aria-expanded', 'false');
    selectElement.setAttribute('aria-hidden', 'true');
  }
});
